export default "__VITE_ASSET__Cp9t5dzt__"